import React, {useEffect} from 'react';
import {Route, Switch, useRouteMatch} from 'react-router';
import useDispatchWithResult from '../../../../hooks/useDispatchWithResult';
import {fetchConta} from '../../../../store/empresa';
import EmpresaContaDetailPage from './_detail';
import EmpresaContaEditPage from './_edit';

export default function EmpresaContaPage() {
  const dispatch = useDispatchWithResult();
  const match = useRouteMatch();
  const empresaId = match.params.empresaId;
  const id = match.params.id;

  useEffect(() => {
    dispatch(fetchConta({empresaId, id}));
  }, [empresaId, id]);

  return (
      <Switch>
        <Route path="/*/empresas/:empresaId/contas/:id/edit" component={EmpresaContaEditPage} />
        <Route path="/*/empresas/:empresaId/contas/:id" component={EmpresaContaDetailPage} />
      </Switch>);
}
